import { render, staticRenderFns } from "./CardStageOptionInfo.vue?vue&type=template&id=4df71f43&scoped=true&"
import script from "./CardStageOptionInfo.vue?vue&type=script&lang=js&"
export * from "./CardStageOptionInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardStageOptionInfo.vue?vue&type=style&index=0&id=4df71f43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df71f43",
  null
  
)

export default component.exports